import { _ } from "../../polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import FiscalYearEditorWidget from "./FiscalYearEditorWidget/FiscalYearEditorWidget.js";
import fiscalYearProgressBarWidget from "./fiscalYearProgressBarWidget.js";
import FlipWidget from "../FlipWidget/FlipWidget.js";
import optionsBag from "../../../models/options/optionsBag.js";

/**
 * Displays a fiscal year overview with a progress bar showing the status
 * of the year and options to edit or delete the year.
 *
 * @param {fiscalYear} spec.fiscalYear - The fiscal year to view/edit
 * @param {chartOfAccounts[]} spec.chartsOfAccounts - List of selectable chart of accounts
 */
export default class FiscalYearWidget extends Widget {
	constructor({ fiscalYear, chartsOfAccounts = [] }) {
		super(...arguments);

		this._fiscalYear = fiscalYear;
		this._chartsOfAccounts = chartsOfAccounts;

		this.onSaveYear = this._events.createEvent();
		this.onDeleteYear = this._events.createEvent();
		this.onDeleteBudget = this._events.createEvent();

		this._progressBarWidget = fiscalYearProgressBarWidget({
			fiscalYear: this._fiscalYear,
		});

		this._fiscalYearEditorWidget = new FiscalYearEditorWidget({
			fiscalYear: this._fiscalYear,
			chartsOfAccounts: this._chartsOfAccounts,
			showLastActiveMonthPickerPredicate: () =>
				optionsBag.fromId("active-period").isActive(),
		});

		this._flipWidget = new FlipWidget({
			frontRenderable: (html) =>
				html.div(
					{
						class: "client-card-progress-bar width-full progress-inline-text",
					},
					this._progressBarWidget,
				),
			backRenderable: this._fiscalYearEditorWidget,
		});

		this._progressBarWidget.onToggleFiscalYearEditor.register(() =>
			this._flipWidget.toggle(),
		);

		this._fiscalYearEditorWidget.onSave.register(() => {
			this.onSaveYear.trigger();
			this.update();
			this._flipWidget.toggle();
		});

		this._fiscalYearEditorWidget.onDelete.register(
			this.onDeleteYear.trigger,
		);

		this._fiscalYearEditorWidget.onDeleteBudget.register(
			this.onDeleteBudget.trigger,
		);
	}

	setChartsOfAccounts(chartsOfAccounts) {
		this._fiscalYearEditorWidget.setChartsOfAccounts(chartsOfAccounts);
	}

	renderContentOn(html) {
		const isActive = this._fiscalYear.isActive();

		html.div(
			{ class: "clearfix" },
			html.div(
				{
					class: [
						"fiscal-year",
						{ active: isActive, inactive: !isActive },
					],
					id: this._fiscalYear.getId(),
				},
				html.div(
					this._fiscalYear.toSmartString(),
					html.a(
						{
							class: "pull-right",
							"data-test": "edit-fiscal-year",
							click: () => this._flipWidget.toggle(),
						},
						_("Edit"),
					),
				),
				this._flipWidget,
			),
		);
	}
}
